(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-plan-visual-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('block-plan-visual-options')) {
  customElements.define('block-plan-visual-options', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('variant-selects').then(() => this.init());
    }
    init() {
      if(this.ready || !this.isConnected) return;
      this.native = document.getElementById(`variant-selects-${this.dataset.section}`);
      if(!this.native) return;
      this.selects = Array.from(this.native.querySelectorAll('select'));
      if(this.selects.length !== 3) return;
      this.data = JSON.parse(this.querySelector('[data-hv-data]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.data.currency});
      this.form = document.getElementById(this.dataset.form);
      if(!this.form) return;
      this.colourProperty = document.createElement('input');
      this.colourProperty.type = 'hidden';
      this.colourProperty.name = `properties[${this.data.colourProperty}]`;
      this.colourProperty.disabled = true;
      this.form.appendChild(this.colourProperty);
      this.scopeProperty=document.createElement('input');
      this.scopeProperty.type='hidden';
      this.scopeProperty.name=`properties[${this.data.scopeProperty}]`;
      this.form.appendChild(this.scopeProperty);
      this.onColour = e => { if(e.target.matches('[data-hv-colour],[data-hv-other]')) this.update(); };
      this.onSubmit = e => {
        this.update();
        const other = this.querySelector('[data-hv-other]');
        if(!other.disabled && !other.value.trim()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          other.setCustomValidity(this.data.colourRequired);
          other.reportValidity();
          other.focus();
        }
      };
      this.addEventListener('input',this.onColour);
      this.addEventListener('change',this.onColour);
      this.form.addEventListener('submit',this.onSubmit,true);
      this.onChoice = e => {
        const radio = e.target.closest('input[data-option]');
        if(!radio) return;
        const select = this.selects[Number(radio.dataset.option)];
        select.value = radio.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
        this.update();
      };
      this.onNative = () => this.update();
      this.onQuantity = e => { if(e.target.name === 'quantity' && (e.target.form === this.form || e.target.closest('form') === this.form)) this.update(); };
      this.addEventListener('change',this.onChoice);
      this.native.addEventListener('change',this.onNative);
      document.addEventListener('input',this.onQuantity);
      document.addEventListener('change',this.onQuantity);
      this.ready = true;
      this.update();
      this.hidden = false;
      this.native.classList.add('hv-native-hidden');
    }
    disconnectedCallback() {
      this.native?.classList.remove('hv-native-hidden');
      this.native?.removeEventListener('change',this.onNative);
      this.removeEventListener('change',this.onChoice);
      document.removeEventListener('input',this.onQuantity);
      document.removeEventListener('change',this.onQuantity);
      this.removeEventListener('input',this.onColour);
      this.removeEventListener('change',this.onColour);
      this.form?.removeEventListener('submit',this.onSubmit,true);
      this.colourProperty?.remove();
      this.scopeProperty?.remove();
      this.ready = false;
    }
    update() {
      const options = this.selects.map(s=>s.value);
      this.querySelectorAll('input[data-option]').forEach(r=>{r.checked = r.value === options[Number(r.dataset.option)];});
      const v = this.data.variants.find(v=>v.options.every((o,i)=>o===options[i]));
      if(!v) {this.querySelector('[data-hv-selection]').textContent=this.data.unavailable;this.querySelector('[data-hv-unit]').textContent='—';this.querySelector('[data-hv-total]').textContent='—';return;}
      const q = Number(this.form?.querySelector('[name="quantity"]')?.value || document.querySelector(`[name="quantity"][form="${this.dataset.form}"]`)?.value || 1);
      const digital=options[0]==='Design only';
      this.scopeProperty.disabled=!digital;
      this.scopeProperty.value=digital?this.data.digitalScope:'';
      this.querySelector('[data-hv-group="1"]').hidden=digital;
      this.querySelector('.hv-preview').hidden=digital;
      this.querySelector('[data-hv-digital]').hidden=!digital;
      this.querySelector('[data-hv-tax]').textContent=digital?this.data.digitalTax:this.data.physicalTax;
      this.querySelector('[data-hv-selection]').textContent=(digital?[options[0],options[2]]:options).join(' · ');
      this.querySelector('[data-hv-unit]').textContent=this.money.format(v.price/100);
      this.querySelector('[data-hv-total]').textContent=Number.isInteger(q)&&q>0?this.money.format(v.price*q/100):'—';
      this.querySelector('[data-hv-finish]').textContent=options[1];
      this.querySelector('[data-hv-size]').textContent=`${options[2]} · ${options[2]==='A3'?this.data.a3:this.data.a2}`;
      this.querySelector('[data-hv-upload]').textContent=digital?this.data.digitalHelp:(options[0]==='Print only'?this.data.printHelp:this.data.designHelp);
      const engraved=!digital && options[1]==='Traffolyte Engraved';
      const img=this.querySelector('.hv-preview-image');
      const sample=options[1]==='White Allupanel'?this.data.white:this.data.brushed;
      img.hidden=engraved || !sample;
      this.querySelector('[data-hv-material-example]').hidden=engraved || !!sample;
      this.querySelector('[data-hv-colours]').hidden=!engraved;
      const colour = this.querySelector('[data-hv-colour]:checked');
      const isOther = engraved && colour.value==='other';
      const other = this.querySelector('[data-hv-other]');
      this.querySelector('[data-hv-other-wrap]').hidden=!isOther;
      other.disabled=!isOther;
      other.required=isOther;
      other.setCustomValidity('');
      const label = isOther ? `${colour.dataset.label}: ${other.value.trim()} (${this.data.pending})` : colour.dataset.label;
      this.colourProperty.disabled=!engraved;
      this.colourProperty.value=engraved?label:'';
      const panel=this.querySelector('[data-hv-engraved]');
      panel.hidden=!engraved;
      const pairs={white_black:['#ffffff','#151515'],black_white:['#151515','#ffffff'],red_white:['#b92228','#ffffff'],white_red:['#ffffff','#b92228'],other:['#e8ebec','#4d5659']};
      const pair=pairs[colour.value];
      panel.style.setProperty('--hv-panel-bg',pair[0]);
      panel.style.setProperty('--hv-panel-fg',pair[1]);
      this.querySelector('[data-hv-panel-caption]').textContent=isOther?this.data.otherCaption:this.data.panelCaption;
      if(engraved) {
        this.querySelector('[data-hv-selection]').textContent=options.join(' · ')+' · '+label;
        this.querySelector('[data-hv-finish]').textContent=options[1]+' · '+label;
      }
      this.querySelector('[data-hv-shared]').hidden=options[1]!=='Silver Brushed Allupanel';
      if(!engraved && sample) {img.removeAttribute('srcset');img.src=sample;img.alt=options[1];}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hydrant-visual-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hydrant-visual-options')) {
  customElements.define('hydrant-visual-options', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('variant-selects').then(() => this.init());
    }
    init() {
      if(this.ready || !this.isConnected) return;
      this.native = document.getElementById(`variant-selects-${this.dataset.section}`);
      if(!this.native) return;
      this.selects = Array.from(this.native.querySelectorAll('select'));
      if(this.selects.length !== 3) return;
      this.data = JSON.parse(this.querySelector('[data-hv-data]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency',currency:this.data.currency});
      this.form = document.getElementById(this.dataset.form);
      if(!this.form) return;
      this.colourProperty = document.createElement('input');
      this.colourProperty.type = 'hidden';
      this.colourProperty.name = `properties[${this.data.colourProperty}]`;
      this.colourProperty.disabled = true;
      this.form.appendChild(this.colourProperty);
      this.onColour = e => { if(e.target.matches('[data-hv-colour],[data-hv-other]')) this.update(); };
      this.onSubmit = e => {
        this.update();
        const other = this.querySelector('[data-hv-other]');
        if(!other.disabled && !other.value.trim()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          other.setCustomValidity(this.data.colourRequired);
          other.reportValidity();
          other.focus();
        }
      };
      this.addEventListener('input',this.onColour);
      this.addEventListener('change',this.onColour);
      this.form.addEventListener('submit',this.onSubmit,true);
      this.onChoice = e => {
        const radio = e.target.closest('input[data-option]');
        if(!radio) return;
        const select = this.selects[Number(radio.dataset.option)];
        select.value = radio.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
        this.update();
      };
      this.onNative = () => this.update();
      this.onQuantity = e => { if(e.target.name === 'quantity' && (e.target.form === this.form || e.target.closest('form') === this.form)) this.update(); };
      this.addEventListener('change',this.onChoice);
      this.native.addEventListener('change',this.onNative);
      document.addEventListener('input',this.onQuantity);
      document.addEventListener('change',this.onQuantity);
      this.ready = true;
      this.update();
      this.hidden = false;
      this.native.classList.add('hv-native-hidden');
    }
    disconnectedCallback() {
      this.native?.classList.remove('hv-native-hidden');
      this.native?.removeEventListener('change',this.onNative);
      this.removeEventListener('change',this.onChoice);
      document.removeEventListener('input',this.onQuantity);
      document.removeEventListener('change',this.onQuantity);
      this.removeEventListener('input',this.onColour);
      this.removeEventListener('change',this.onColour);
      this.form?.removeEventListener('submit',this.onSubmit,true);
      this.colourProperty?.remove();
      this.ready = false;
    }
    update() {
      const options = this.selects.map(s=>s.value);
      this.querySelectorAll('input[data-option]').forEach(r=>{r.checked = r.value === options[Number(r.dataset.option)];});
      const v = this.data.variants.find(v=>v.options.every((o,i)=>o===options[i]));
      if(!v) {this.querySelector('[data-hv-selection]').textContent=this.data.unavailable;this.querySelector('[data-hv-unit]').textContent='—';this.querySelector('[data-hv-total]').textContent='—';return;}
      const q = Number(this.form?.querySelector('[name="quantity"]')?.value || document.querySelector(`[name="quantity"][form="${this.dataset.form}"]`)?.value || 1);
      this.querySelector('[data-hv-selection]').textContent=options.join(' · ');
      this.querySelector('[data-hv-unit]').textContent=this.money.format(v.price/100);
      this.querySelector('[data-hv-total]').textContent=Number.isInteger(q)&&q>0?this.money.format(v.price*q/100):'—';
      this.querySelector('[data-hv-finish]').textContent=options[1];
      this.querySelector('[data-hv-size]').textContent=`${options[2]} · ${options[2]==='A3'?this.data.a3:this.data.a2}`;
      this.querySelector('[data-hv-upload]').textContent=options[0]==='Print only'?this.data.printHelp:this.data.designHelp;
      const engraved=options[1]==='Traffolyte Engraved';
      const img=this.querySelector('.hv-preview-image');
      img.hidden=engraved;
      this.querySelector('[data-hv-colours]').hidden=!engraved;
      const colour = this.querySelector('[data-hv-colour]:checked');
      const isOther = engraved && colour.value==='other';
      const other = this.querySelector('[data-hv-other]');
      this.querySelector('[data-hv-other-wrap]').hidden=!isOther;
      other.disabled=!isOther;
      other.required=isOther;
      other.setCustomValidity('');
      const label = isOther ? `${colour.dataset.label}: ${other.value.trim()} (${this.data.pending})` : colour.dataset.label;
      this.colourProperty.disabled=!engraved;
      this.colourProperty.value=engraved?label:'';
      const panel=this.querySelector('[data-hv-engraved]');
      panel.hidden=!engraved;
      const pairs={white_black:['#ffffff','#151515'],black_white:['#151515','#ffffff'],red_white:['#b92228','#ffffff'],white_red:['#ffffff','#b92228'],other:['#e8ebec','#4d5659']};
      const pair=pairs[colour.value];
      panel.style.setProperty('--hv-panel-bg',pair[0]);
      panel.style.setProperty('--hv-panel-fg',pair[1]);
      this.querySelector('[data-hv-panel-caption]').textContent=isOther?this.data.otherCaption:this.data.panelCaption;
      if(engraved) {
        this.querySelector('[data-hv-selection]').textContent=options.join(' · ')+' · '+label;
        this.querySelector('[data-hv-finish]').textContent=options[1]+' · '+label;
      }
      this.querySelector('[data-hv-shared]').hidden=options[1]!=='Silver Brushed Allupanel';
      if(!engraved) {img.removeAttribute('srcset');img.src=options[1]==='White Allupanel'?this.data.white:this.data.brushed;img.alt=options[1];}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ss-price-match"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ss-price-match').forEach(function(root){
 const details=root.querySelector('details');
 if(root.querySelector('.ss-price-match__success,.errors') || location.hash.startsWith('#PriceMatch-')) details.open=true;
 details.addEventListener('toggle',function(){
  if(!details.open) return;
  const productForm=document.getElementById(root.dataset.productForm);
  if(!productForm) return;
  const id=productForm.querySelector('[name="id"]');
  const option=Array.from(root.querySelector('[data-pm-variant]').options).find(function(o){return id && o.dataset.variantId===id.value;});
  if(option) option.selected=true;
  const qty=document.querySelector('[name="quantity"][form="'+root.dataset.productForm+'"]') || productForm.querySelector('[name="quantity"]');
  if(qty) root.querySelector('[data-pm-quantity]').value=qty.value;
 });
});
  } catch(e) { console.error(e); }
})();

})();
